import React from 'react';
import { GameSelector } from '../components/GameSelector';
import { AudienceSelector } from '../components/AudienceSelector';
import { BudgetScheduler } from '../components/BudgetScheduler';

const CampaignForm = ({ form, games, audiences, cards }: any) => {
  return (
    <div className='bg-white p-8 rounded-2xl space-y-3'>
      {/* Campaign Name */}
      <div className='rounded-xl overflow-hidden bg-[#F5F5F5] p-4'>
        <label className='block text-sm font-medium text-gray-700'>
          Campaign Name
        </label>
        <div className='bg-white'>
          <input
            type='text'
            value={form.campaignName}
            onChange={(e) => form.setCampaignName(e.target.value)}
            placeholder='New Campaign Name'
            className='mt-1 block w-full border-b border-gray-300 px-3 py-2 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500'
          />
        </div>
      </div>

      <GameSelector
        games={games}
        selectedId={form.selectedGameId}
        onSelect={form.setSelectedGameId}
      />

      <AudienceSelector
        audiences={audiences}
        selectedId={form.selectedAudienceId}
        newName={form.newAudienceName}
        onSelect={form.setSelectedAudienceId}
        onNewName={form.setNewAudienceName}
        setNewGender={form.setNewGender}
        newGender={form.newGender}
        setNewAgeRange={form.setNewAgeRange}
        newAgeRange={form.newAgeRange}
        locations={form.locations}
        setLocations={form.setLocations}
      />

      <BudgetScheduler
        start={form.startDate}
        end={form.endDate}
        totalDays={form.totalDays}
        daily={form.dailyBudget}
        onStart={form.setStartDate}
        onEnd={form.setEndDate}
        onDaily={form.setDailyBudget}
      />

    </div>
  );
};

export default CampaignForm;
